exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-new {\n  background-color: #fffbe6;\n  padding: 8px;\n  margin-bottom: 16px;\n  clear: both;\n}\n", ""]);

// exports
